(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
// Mobile Menu Toggle for Footer
(function() {
  if (window.innerWidth <= 767) {
    var footerTitles = document.querySelectorAll('.footer-title');
    
    footerTitles.forEach(function(title) {
      title.style.cursor = 'pointer';
      title.addEventListener('click', function() {
        var content = this.nextElementSibling;
        if (content && content.classList.contains('footer-content')) {
          content.style.display = content.style.display === 'none' ? 'block' : 'none';
        }
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
